import { createStore } from 'zustand'

import { AssignManagerStore, CreateAssignManagerOptions } from './interface'

export const createAssignManagerStore = ({
  tableRef
}: CreateAssignManagerOptions) =>
  createStore<AssignManagerStore>((set, get) => ({
    tableRef,
    members: [],
    setMembers(members) {
      set({ members })
    },
    assignFormVisible: false,
    toggleAssignFormVisible() {
      const assignFormVisible = !get().assignFormVisible
      set({ assignFormVisible })

      // 关闭时清空数据
      if (!assignFormVisible) {
        set({ members: [] })
      }
    }
  }))
